import { Component, Inject, OnInit } from '@angular/core';
import { EditOverviewComponent } from '../../business/edit-overview/edit-overview.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Tag } from '../models/tag.model';
import { AirportService } from '../../airport/airport.service';
import { TagService } from '../services/tag.service';

@Component({
  selector: 'app-edit-tags',
  templateUrl: './edit-tags.component.html',
  styleUrls: ['./edit-tags.component.scss']
})

export class EditTagsComponent implements OnInit {
  business: any;
  allTags: Tag[];
  disableClose = false;
  tags: Tag[] = [];
  tagsGroup: string[] = [];
  title = '';
  except: string[] = null;
  isLoading = true;
  constructor(private _matDialogRef: MatDialogRef<EditOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private _airportService: AirportService,
    private _tagService: TagService) {
    this.business = data.business;
    this.tagsGroup = data.tagsGroup;
    this.title = data.title;
    if (data.except) {
      this.except = data.except;
    }
  }

  async ngOnInit() {
    try {
      this.allTags = await this._tagService.getAllTags();
    } catch (e) {
      this.handleError();
    }
    if (this.business.airportId) {
      this.business = await this._airportService.getAirport(this.business.identifier.toString());
    }
    this.isLoading = false;
    this.parseTagNames();
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(true);
    });
  }

  /* tagGroup: String[] -> If a tag matches an element in tagGroup we keep it.
        -> Eg. tagGroup = ['Amenities::']
        -> All tags that match 'Amentities::' will be pushed to tags array
     except: String[]  -> If a tag matches an element in except then it will be excluded.
        -> Eg. except = ['Amenities::Internet::']
        -> Any tag with 'Amentities::Internet::' will be excluded from the tags array
  The method will check the tags in tagGroup and match them against all the tags. If any tag
  matches an element in tagsGroup then it will be added into the final result unless its in except. */
  parseTagNames() {
    if (this.tagsGroup.length > 0) {
      for (const aTag of this.allTags) {
        const tagName = aTag.tagName;
        if (!tagName.includes('::') || (this.tagsGroup.every(tag => !tagName.includes(tag)))) {
          continue;
        } else if (this.except && this.except.length > 0 && this.except.some(tagToExclude => tagName.includes(tagToExclude))) {
          continue;
        } else {
          // The length check is on the off chance that something like Maintenance::Airframe::Manufacturers:: exists in tags
          if (this.tagsGroup.some(tag => tagName.includes(tag) && tagName.length !== tag.length)) {
            this.tags.push(aTag);
          }
        }
      }
    }
  }

  async checkBoxChanged() {
    this.disableClose = true;
    this._matDialogRef.disableClose = true;
    try {
      let id;
      id = this.business.id || this.business.airportId;
      if (this.business.id) {
        Object.assign(this.business, await this._airportService.getBusiness(id.toString()));
      }
    } catch (e) {
      this.handleError();
    }
    this.disableClose = false;
    this._matDialogRef.disableClose = false;
  }

  async close() {
    if (this.business) {
      this._matDialogRef.close(true);
    }
  }

  handleError() {
    this._matDialogRef.close(false);
  }
}
